import React, { useEffect, useState } from 'react';
import './Deposit.css';
import { authService } from '../services/authService';
import { useNavigate } from 'react-router-dom';

const Withdraw = () => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [bankDetails, setBankDetails] = useState(null);
  const [bankLoading, setBankLoading] = useState(true);

  const navigate = useNavigate();

  /* =========================
     FETCH BANK DETAILS
  ========================= */
  useEffect(() => {
    const fetchBankDetails = async () => {
      const token = authService.getToken();
      if (!token) {
        setBankLoading(false);
        return;
      }

      try {
        const res = await fetch(
          'https://playinbyd.com/api/api-get-user-bank-details',
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
              env_type: 'Prod',
              unique_jwt_token: token
            })
          }
        );

        const data = await res.json();

        if (data.success && data.bank_details) {
          setBankDetails(data.bank_details);
        } else {
          setBankDetails(null);
        }
      } catch (err) {
        console.error(err);
        setBankDetails(null);
      } finally {
        setBankLoading(false);
      }
    };

    fetchBankDetails();
  }, []);

  /* =========================
     WITHDRAW SUBMIT
  ========================= */
  const validate = () => {
    if (!amount || Number(amount) <= 0) {
      setError('Withdrawal amount must be greater than 0');
      return false;
    }
    if (!bankDetails) {
      setError('Please add bank details before withdrawing.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!validate()) return;

    const token = authService.getToken();
    if (!token) {
      setError('Session expired. Please login again.');
      return;
    }

    const payload = {
      app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
      env_type: 'Prod',
      unique_jwt_token: token,
      request_amount: amount.toString()
    };

    try {
      setLoading(true);

      const res = await fetch(
        'https://playinbyd.com/api/api-user-withdraw-fund-request',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }
      );

      const data = await res.json();

      if (data.success) {
        setSuccess(data.msg || 'Withdrawal request submitted successfully');
        setAmount('');
      } else {
        setError(data.msg || 'Withdrawal request failed');
      }
    } catch (err) {
      setError('Server error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bet-history-page">
      {/* PAGE HEADER */}
      {/* <div className="page-header">
        <div>
          <h1 className="page-title">Withdraw</h1>
          <p className="page-subtitle">Request withdrawal from your wallet</p>
        </div>
      </div> */}

   
        <div className="deposit-page">
          <div className="main-card">
          <div className='main-card-header'> 
          <h1 className="page-title">Withdraw</h1>
        </div>
     

            {/* =========================
               BANK DETAILS SECTION
            ========================= */}
            {bankLoading ? (
              <p className="page-subtitle">Loading bank details...</p>
            ) : bankDetails ? (
              <div className="bank-details-box">
                <h3>Linked Bank Account</h3>
                <p><strong>Bank:</strong> {bankDetails.bank_name}</p>
                <p><strong>Account Holder:</strong> {bankDetails.ac_holder_name}</p>
                <p>
                  <strong>Account No:</strong>{' '}
                  ****{bankDetails.ac_number?.slice(-4)}
                </p>
                <p><strong>IFSC:</strong> {bankDetails.ifsc_code}</p>

                <button
                  type="button"
                  className="link-btn"
                  onClick={() => navigate('/bank-details')}
                >
                  Edit Bank Details
                </button>
              </div>
            ) : (
              <div className="bank-warning-box">
                <p>User bank or UPI details not found.</p>
                <button
                  className="submit-btn"
                  type="button"
                  onClick={() => navigate('/bank-details')}
                >
                  Add Bank Details
                </button>
              </div>
            )}

            {/* =========================
               WITHDRAW FORM
            ========================= */}
            <form className="deposit-form" onSubmit={handleSubmit}>
            <div className="form-group">
  <label>Amount *</label>
  <input
    type="number"
    placeholder="Enter withdrawal amount"
    value={amount}
    onChange={(e) => {
      const value = e.target.value;
      // Only accept positive numbers or empty string
      if (value === '' || parseFloat(value) >= 0) {
        setAmount(value);
      }
    }}
    min="0" // HTML5 min attribute prevents negative in browser
    disabled={!bankDetails}
  />
</div>

              <button
                type="submit"
                className="submit-btn"
                disabled={loading || !bankDetails}
              >
                {loading ? 'Processing...' : 'Submit Withdrawal'}
              </button>

              {error && <div className="error">{error}</div>}
              {success && <div className="success">{success}</div>}
            </form>

          </div>
        </div>
   
    </div>
  );
};

export default Withdraw;
